






import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';
import {Context} from '@braid/vue-formulate/src/Formulate';

@Component({})
class FaBoxComponent extends Vue {
    static COMPONENT_NAME = 'fa-box-component';

    @Prop({type: Object, required: true}) context!: Context

    protected box!: string;

    get icon(): [string, string] {
        if (this.isChecked()) {
            return ['far', `check-${this.box}`]
        }

        return ['far', this.box]
    }

    protected isChecked(): boolean {
        return this.context.model === this.context.value;
    }
}

export default FaBoxComponent;
